<template>
  <nav v-if="!isLastStep" class="multistep-form-controls">
    <div class="multistep-form-controls__button-wrapper">
      <BaseButton
        v-if="!isFirstStep"
        outlined
        title="Go to previous step"
        class="multistep-form-controls__button"
        @click="emit('setPreviousStep')"
        data-testid="button_previous"
      >
        <template #text>
          <span>&lt; Previous</span>
        </template>
      </BaseButton>
    </div>
    <div class="multistep-form-controls__button-wrapper">
      <BaseButton
        v-if="currentStep < 5"
        title="Go to next step"
        class="multistep-form-controls__button"
        @click="emit('setNextStep')"
        data-testid="button_next"
        :disabled="isDisabled"
      >
        <template #text>
          <span v-if="isFirstStep">Start the survey &gt;</span>
          <span v-else>Next &gt;</span>
        </template>
      </BaseButton>
      <BaseButton
        v-else
        title="Submit form"
        class="multistep-form-controls__button"
        @click="onSubmit"
        data-testid="button_submit"
      >
        <template #text>
          <span v-if="!isLoading">Submit ></span>
          <LoaderSpinner v-else white class="multistep-form-controls__loader" />
        </template>
      </BaseButton>
    </div>
  </nav>
</template>

<script lang="ts" setup>
interface Props {
  currentStep: number
  isLastStep: boolean
  isFirstStep: boolean
  isLoading: boolean
  isDisabled?: boolean
}

const props = defineProps<Props>()
const emit = defineEmits(['setPreviousStep', 'setNextStep', 'submitForm'])

const onSubmit = () => {
  if (props.isLoading) return

  emit('submitForm')
}
</script>

<style lang="scss" scoped>
.multistep-form-controls {
  width: 100%;
  display: flex;
  justify-content: space-between;

  &__loader {
    transform: scale(0.4) translateY(-70px);
  }

  &__button {
    height: 48px;
  }
}
</style>
